module.exports = "## State of the art JPEG compression\r\n\r\nJPEG is the most used image format on the world wide web. This is because it uses a lossy (irreversible) compression algorithm. However, most of the JPEG images you produced by digital cameras or download from the web are not compressed to the full extent. \r\n\r\nThis is where our intelligent JPEG Compressor come to the rescue. It allows you to save as much as 90% of the original file size without losing visible image quality."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-section-two.md
// module id = 1161
// module chunks = 0